import React, { FC } from "react";
import { Dialog, DialogProps } from "@material-ui/core";
import useStyles from "./styles";

const DPDialog: FC<DialogProps> = ({ children, ...rest }) => {
  const classes = useStyles();

  return (
    <Dialog
      disableBackdropClick={true}
      classes={{ paper: classes.paper }}
      fullWidth
      {...rest}
    >
      <div className={classes.content}>
        {children}
      </div>
    </Dialog>
  );
};

export default DPDialog;
